var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#7EE989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0493 36.9073C37.3198 40.5935 32.9391 42.9832 28.0002 42.9832C20.142 42.9832 13.6967 36.9335 13.0677 29.2374H17.3916V26.6809L10.3157 26.6809C10.2836 27.1165 10.2673 27.5565 10.2673 28.0003C10.2673 37.7939 18.2066 45.7332 28.0002 45.7332C34.5471 45.7332 40.2653 42.1853 43.3372 36.9073H40.0493Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9257 26.6809H39.1093V29.2374H42.9327C42.9327 29.2374 42.9327 29.2375 42.9327 29.2374L45.6906 29.2375C45.7187 28.8287 45.733 28.4162 45.733 28.0003C45.733 18.2067 37.7938 10.2675 28.0002 10.2675C21.174 10.2675 15.2487 14.1245 12.2847 19.778H15.473C18.1512 15.7058 22.7618 13.0175 28.0002 13.0175C35.8304 13.0175 42.2577 19.0241 42.9257 26.6809Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4577 20.7008L28.0496 33.1698L32.5938 20.7008H36.0616L29.6281 36.9149H26.4472L19.9897 20.7008H23.4577Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVires);
export default __webpack_public_path__ + "static/media/VIRES.96d459fe5f65b3a415d1dc546068bd6a.svg";
export { ForwardRef as ReactComponent };